import Vue from 'vue'
import moment from 'moment'
import _ from 'lodash'
import proj4 from 'proj4'

import api from '../../api'
import maps_api from '../../maps_api'

import chunk from '../../../functions/global_functions'

import {
    CREATE_NEW_REALESTATE,
    DELETE_REALESTATE,
    RESET_REALESTATE,
    SET_REALESTATE,
    SET_REALESTATE_CADASTRAL_REFERENCE,
    SET_REALESTATE_CENSUS_SECTION_CODE,
    SET_REALESTATE_COUNTRY,
    SET_REALESTATE_DATE_CREATED,
    SET_REALESTATE_DATE_MODIFIED,
    SET_REALESTATE_DESCRIPTION,
    SET_REALESTATE_DIRTYNESS,
    SET_REALESTATE_DOOR,
    SET_REALESTATE_EPSG25831_X,
    SET_REALESTATE_EPSG25831_Y,
    SET_REALESTATE_FLOOR,
    SET_REALESTATE_FLOOR_NUMBER,
    SET_REALESTATE_GEOHASH,
    SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS,
    SET_REALESTATE_GOOGLE_VIEWPORT,
    SET_REALESTATE_ID,
    SET_REALESTATE_LAT,
    SET_REALESTATE_LNG,
    SET_REALESTATE_MUNICIPALITY,
    SET_REALESTATE_PARENT_PATH,
    SET_REALESTATE_PATH,
    SET_REALESTATE_POSTAL_CODE,
    SET_REALESTATE_PROPERTY_TYPE,
    SET_REALESTATE_PROVINCE,
    SET_REALESTATE_REGISTRY_NAME,
    SET_REALESTATE_STAIRCASE,
    SET_REALESTATE_STREET_NAME,
    SET_REALESTATE_STREET_NUMBER,
    SET_REALESTATE_MAP_GOOGLE_01_URL,
    SET_REALESTATE_MAP_GOOGLE_01_LAT,
    SET_REALESTATE_MAP_GOOGLE_01_LNG,
    SET_REALESTATE_MAP_GOOGLE_01_ZOOM,
    SET_REALESTATE_MAP_GOOGLE_02_URL,
    SET_REALESTATE_MAP_GOOGLE_02_LAT,
    SET_REALESTATE_MAP_GOOGLE_02_LNG,
    SET_REALESTATE_MAP_GOOGLE_02_ZOOM,
    SET_REALESTATE_MAP_GOOGLE_03_URL,
    SET_REALESTATE_MAP_GOOGLE_03_LAT,
    SET_REALESTATE_MAP_GOOGLE_03_LNG,
    SET_REALESTATE_MAP_GOOGLE_03_ZOOM,
    SET_REALESTATE_FULL_ADDRESS,
    SET_REALESTATE_SHORT_ADDRESS,
    SET_REALESTATE_BLOCK,
    SET_REALESTATE_AREA_ADS_MARKERS,
    SET_REALESTATE_AREA_AVERAGE_PRICE,
    SET_REALESTATE_AREA_AVERAGE_PRICE_COEF,
    SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE,
    SET_REALESTATE_ESTIMATED_BUILT_AREA,
    SET_REALESTATE_PRE_APPRAISAL_VALUE,
    SET_REALESTATE_TRAVEL_ONE_WAY_HOURS,
    SET_REALESTATE_TRAVEL_BOTH_WAYS_HOURS,
    SET_REALESTATE_TRAVEL_FEES_PER_HOUR,
    SET_REALESTATE_CAR_FUEL_EXPENSES_ONE_WAY,
    SET_REALESTATE_CAR_FUEL_EXPENSES_BOTH_WAYS,
    SET_REALESTATE_CAR_TOLL_EXPENSES_ONE_WAY,
    SET_REALESTATE_CAR_TOLL_EXPENSES_BOTH_WAYS,
    SET_REALESTATE_CAR_EXPENSES_ONE_WAY,
    SET_REALESTATE_CAR_EXPENSES_BOTH_WAYS,
    SET_REALESTATE_TOTAL_TRAVEL_FEES,
    SET_REALESTATE_QUOTE_BASE_FEES,
    SET_REALESTATE_QUOTE_EXCESS_PCT,
    SET_REALESTATE_QUOTE_BASE_PRICE,
    SET_REALESTATE_QUOTE_BASE_PRICE_COEF,
    SET_REALESTATE_QUOTE_APPRAISAL_TYPE_IS_ECO,
    SET_REALESTATE_AREA_ADS_QUERY_STARTDATE,
    SET_REALESTATE_AREA_ADS_QUERY_LIMITDATE,
    SET_REALESTATE_AREA_ADS_QUERY_DISTANCE,
    SET_REALESTATE_QUOTE_PRICE_INCL_TRAVEL_EXPENSES,
    SET_REALESTATE_INVOICE_BASE_FEES,
    SET_REALESTATE_INVOICE_EXCESS_PCT,
    SET_REALESTATE_INVOICE_BASE_PRICE,
    SET_REALESTATE_INVOICE_BASE_PRICE_COEF,
    SET_REALESTATE_INVOICE_APPRAISAL_TYPE_IS_ECO,
    SET_REALESTATE_QUOTE_EXCESS,
    SET_REALESTATE_ASSET_TYPE,
    SET_REALESTATE_DWELLING_TYPE,
    SET_REALESTATE_FLOOR_TYPE,
    UPDATE_REALESTATE
} from '../../constants'

const default_state = {
    appraisalreports: null,
    cadastral_reference: null,
    census_section_code: null,
    country: {
        iso_3166_alpha2_code: 'ES',
        name_en: 'Spain'
    },
    description: null,
    door: null,
    floor: null,
    floor_number: null,
    floor_type: null,
    geohash: null,
    google_formatted_address: null,
    google_viewport: null,
    lat: null,
    lng: null,
    municipality: null,
    parent_path: null,
    postal_code: null,
    property_type: null,
    province: null,
    registry_name: null,
    registry_estate_number: null,
    staircase: null,
    street_name: null,
    street_number: null,
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    map_google_01_url: null,
    map_google_01_lat: null,
    map_google_01_lng: null,
    map_google_01_zoom: 13,
    map_google_02_url: null,
    map_google_02_lat: null,
    map_google_02_lng: null,
    map_google_02_zoom: 16,
    map_google_03_url: null,
    map_google_03_lat: null,
    map_google_03_lng: null,
    map_google_03_zoom: 19,
    full_address: null,
    short_address: null,
    block: null,
    area_ads_markers: null,
    area_average_price: null,

    area_average_price_coef: 0.95,
    adopted_area_average_price: null,
    estimated_built_area: null,
    pre_appraisal_value: null,
    travel_one_way_hours: null,
    travel_both_ways_hours: null,
    travel_fees_per_hour: 20,
    car_fuel_expenses_one_way: null,
    car_fuel_expenses_both_ways: null,
    car_toll_expenses_one_way: null,
    car_toll_expenses_both_ways: null,
    car_expenses_one_way: null,
    car_expenses_both_ways: null,
    total_travel_fees: null,
    quote_base_fees: null,
    quote_excess_pct: null,
    quote_base_price: null,
    quote_base_price_coef: 1,
    quote_appraisal_type_is_eco: null,
    area_ads_query_startdate: null,
    area_ads_query_limitdate: null,
    area_ads_query_distance: 1,
    quote_price_incl_travel_expenses: null,
    invoice_base_fees: null,
    invoice_excess_pct: null,
    invoice_base_price: null,
    invoice_base_price_coef: 1,
    invoice_appraisal_type_is_eco: null,
    quote_excess: null,
    asset_type: null,
    dwelling_type: null,

}

const state = default_state

const actions = {

    QUERY_MUNICIPALITIES: ({state, commit, rootState}, data) => {

        // console.log('query_municipalities data:')
        // console.log(data)
        api.get({path: 'municipalities/'})
            .then((res) => {
                return new Promise((resolve, reject) => {
                    setTimeout(() => {

                        //console.log(res)
                        const res_array = _.values(res)
                        console.log('res_array: ')
                        console.log(res_array)
                        const results = res_array.filter((element, index, array) => {
                            console.log('data.query: ')
                            console.log(data.query)
                            return element.name_ine.toLowerCase().includes(data.query.toLowerCase())
                        })
                        resolve(results)
                    }, 1000)
                })
            })

    },

    CREATE_NEW_REALESTATE: ({state, commit, rootState}, data) => {

        return new Promise((resolve, reject) => {
            api.create({path: data.path})
                .then((res) => {
                    const new_created_key = res.key

                    commit(SET_REALESTATE_ID, new_created_key)
                    commit(SET_REALESTATE_DATE_CREATED, res.date_created)
                    commit(SET_REALESTATE_DATE_MODIFIED, res.date_modified)
                    // commit(SET_REALESTATE_PARENT_PATH, data.parent_path)
                    commit(SET_REALESTATE_PATH, res.path)

                    api.set_value({value: res.key, path: data.path + res.key + '/' + 'id', save_timestamp: false})

                    api.set_value({
                        value: new_created_key,
                        path: data.path + new_created_key + '/' + 'id',
                        save_timestamp: false
                    }).then((res) => {

                        if (data.file_id && data.file_number) {
                            api.set_value({
                                // value: true,
                                value: data.file_number,
                                path: data.path + new_created_key + '/' + 'appraisalfiles' + '/' + data.file_id,
                                save_timestamp: false
                            })
                        }

                        if (data.report_id && data.report_number && data.report_version) {

                            api.set_value({
                                // value: true,
                                value: data.report_number + '.' + data.report_version,
                                path: data.path + new_created_key + '/' + 'appraisalreports' + '/' + data.report_id,
                                save_timestamp: false
                            })

                            api.set_value({
                                value: true,
                                path: 'appraisalreports' + '/' + data.report_id + '/' + 'realestates' + '/' + new_created_key + '/' + 'id',
                                save_timestamp: false
                            }).then(res => resolve({key: new_created_key}))

                        }

                        if (data.quote_id && data.quote_number && data.quote_version) {

                            api.set_value({
                                // value: true,
                                value: data.quote_number + '.' + data.quote_version,
                                path: data.path + new_created_key + '/' + 'appraisalquotes' + '/' + data.quote_id,
                                save_timestamp: false
                            })

                            api.set_value({
                                // value: true,
                                value: new_created_key,
                                path: 'appraisalquotes' + '/' + data.quote_id + '/' + 'realestates' + '/' + new_created_key + '/' + 'id',
                                save_timestamp: false
                            }).then(res => resolve({key: new_created_key}))

                        }

                    })
                })

        })

    },
    DELETE_REALESTATE: ({state, commit, rootState}, data) => {

        console.log('path check: ' + data.path)
        console.log('parent_path check: ' + data.parent_path)

        // delete from contact_addresses/contact_key
        api.delete({key: data.key, path: data.path})
            .then((res) => {


                // delete from contact/contact_key/realestates
                api.delete({key: data.key, path: data.parent_path + data.key})
                    .then((res) => {
                        commit(RESET_REALESTATE)

                    })
            })

    },
    SET_REALESTATE: ({state, commit, rootState}, data) => {

        // console.log('SET_REALESTATE data.path:')
        // console.log(data.path)
        return api.get({path: data.path})
            .then((res) => {
                // console.log('realestate.js api.get res:')
                // console.log(res)
                commit(SET_REALESTATE, res)
            })

    },
    FETCH_REALESTATE: ({state, commit, rootState}, data) => {
        return new Promise((resolve, reject) => {
            return api.get({path: data.path})
                .then((res) => {
                    resolve(res)
                })
        })
    },
    GEOLOCATE_REALESTATE: ({state, commit, rootState}, data) => {

        // console.log('--- geolocate_address data:')
        // console.log(data)
        // console.log('----------')
        return new Promise((resolve, reject) => {
            return maps_api.geolocate(data)
                .then((res) => {
                    console.log(res.results)
                    const result = window.confirm(Vue.i18n.translate('S\'ha trobat via Google la següent adreça: ') + res.formatted_address + '. S\'actualitzaran les dades de geolocalització segons aquesta adreça. És correcte?')

                    if (result) {

                        const new_lat = res.lat
                        const new_lng = res.lng

                        commit(SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS, res.formatted_address)
                        commit(SET_REALESTATE_GOOGLE_VIEWPORT, res.viewport)
                        commit(SET_REALESTATE_LAT, new_lat)
                        commit(SET_REALESTATE_LNG, new_lng)

                        // commit(SET_REALESTATE_MAP_GOOGLE_01_LAT, new_lat)
                        // commit(SET_REALESTATE_MAP_GOOGLE_01_LNG, new_lng)

                        // commit(SET_REALESTATE_MAP_GOOGLE_02_LAT, new_lat)
                        // commit(SET_REALESTATE_MAP_GOOGLE_02_LNG, new_lng)

                        // commit(SET_REALESTATE_MAP_GOOGLE_03_LAT, new_lat)
                        // commit(SET_REALESTATE_MAP_GOOGLE_03_LNG, new_lng)

                        commit(SET_REALESTATE_POSTAL_CODE, res.postal_code)
                        commit(SET_REALESTATE_STREET_NAME, res.street_name)
                        commit(SET_REALESTATE_STREET_NUMBER, res.street_number)

                        const proj4_wgs84 = '+proj=longlat +datum=WGS84 +no_defs'
                        const proj4_epsg25831 = '+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs '

                        const epsg25831_coords = proj4(proj4_wgs84, proj4_epsg25831, [res.lng, res.lat])
                        // console.log('epsg25831_coords: ')
                        // console.log(epsg25831_coords)
                        commit(SET_REALESTATE_EPSG25831_X, epsg25831_coords[0])
                        commit(SET_REALESTATE_EPSG25831_Y, epsg25831_coords[1])

                        if (data.old_geohash) {

                            const old_location_path = 'realestate_locations/' + chunk(data.old_geohash, 1).join('/') + '/' + data.id

                            console.log('old_location_path: ')
                            console.log(old_location_path)

                            api.delete({path: old_location_path}).then((res) => {

                                api.getGeohash({key: data.id, lat: new_lat, lng: new_lng}).then((res) => {
                                    // console.log('realestate.js api.get res:')
                                    // console.log(res)
                                    const new_geohash = res.geohash

                                    const new_location_path = 'realestate_locations/' + chunk(new_geohash, 1).join('/')
                                    const new_object = {}
                                    new_object[data.id] = true

                                    api.set_value({
                                        value: new_object,
                                        path: new_location_path,
                                        save_timestamp: false
                                    }).then((res) => {
                                        commit(SET_REALESTATE_GEOHASH, new_geohash)
                                        resolve(res)
                                    })

                                })

                            })
                        } else {

                            api.getGeohash({key: data.id, lat: res.lat, lng: res.lng}).then((res) => {
                                // console.log('realestate.js api.get res:')
                                // console.log(res)
                                const new_geohash = res.geohash

                                const new_location_path = 'realestate_locations/' + chunk(new_geohash, 1).join('/')
                                const new_object = {}
                                new_object[data.id] = true

                                api.set_value({
                                    value: new_object,
                                    path: new_location_path,
                                    save_timestamp: false
                                }).then((res) => {
                                    commit(SET_REALESTATE_GEOHASH, new_geohash)
                                    resolve(res)
                                })

                            })

                        }

                    }else{
                        resolve({none: true})
                    }

                })
        })

    },
    GOOGLEDISTANCE_REALESTATE: ({state, commit, rootState}, data) => {

        // console.log('--- geolocate_address data:')
        // console.log(data)
        // console.log('----------')
        return new Promise((resolve, reject) => {
            return maps_api.googledistance(data)
                .then((res) => {
                    console.log(res)

                    // commit(SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS, res.formatted_address)

                    resolve(res)

                })
        })

    },
    REQUEST_CENSUS_SECTION_INFO: ({state, commit, rootState}, data) => {

        return maps_api.request_icc_census_section_info(data)
            .then((res) => {

                console.log('request_census_section_info res:')
                console.log(res)

                // parse the html response from ICC
                const div = document.createElement('div')
                div.innerHTML = res.html
                const ths = div.querySelectorAll('th')
                const tds = div.querySelectorAll('td')

                // console.log('div: ')
                // console.log(div)

                let new_ths = []
                let new_tds = []

                for (let i = 0; i < ths.length; i++) {
                    new_ths.push(ths[i].innerText.toLowerCase())
                }

                for (let i = 0; i < tds.length; i++) {
                    new_tds.push(tds[i].innerText.toLowerCase())
                }

                console.log('new_ths: ')
                console.log(new_ths)
                console.log('new_tds: ')
                console.log(new_tds)

                let census_obj = Object.assign({}, ...new_ths.map((n, index) => ({[n]: new_tds[index]})))

                // console.log(census_obj)

                const census_section_code = '' + census_obj.municipi + census_obj.districte + census_obj.seccio

                commit(SET_REALESTATE_CENSUS_SECTION_CODE, census_section_code)

            })

    },
    REQUEST_CADASTRAL_REFERENCE_BY_COORDINATES: ({state, commit, rootState}, data) => {

        return maps_api.request_cadastral_reference_by_coordinates(data)
            .then((res) => {

                console.log('request_cadastral_reference_by_coordinates res:')
                console.log(res)

                if (res.result.consulta_coordenadas_distancias) {
                    const cadref_part1 = res.result.consulta_coordenadas_distancias.coordenadas_distancias.coordd.lpcd.pcd[0].pc.pc1
                    const cadref_part2 = res.result.consulta_coordenadas_distancias.coordenadas_distancias.coordd.lpcd.pcd[0].pc.pc2

                    const cadref = cadref_part1 + cadref_part2

                    commit(SET_REALESTATE_CADASTRAL_REFERENCE, cadref)
                } else {
                    console.log('res.result.consulta_coordenadas_distancias .... is undefined?')
                }

            })

    },
    RESET_REALESTATE: ({state, commit, rootState}) => {
        commit(RESET_REALESTATE)
    },
    SET_REALESTATE_CADASTRAL_REFERENCE: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_CADASTRAL_REFERENCE, data)
    },
    SET_REALESTATE_CENSUS_SECTION_CODE: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_CENSUS_SECTION_CODE, data)
    },
    SET_REALESTATE_COUNTRY: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_COUNTRY, data)
    },
    SET_REALESTATE_DATE_CREATED: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_DATE_CREATED, data)
    },
    SET_REALESTATE_DATE_MODIFIED: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_DATE_MODIFIED, data)
    },
    SET_REALESTATE_DESCRIPTION: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_DESCRIPTION, data)
    },
    SET_REALESTATE_DOOR: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_DOOR, data)
    },
    SET_REALESTATE_EPSG25831_X: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_EPSG25831_X, data)
    },
    SET_REALESTATE_EPSG25831_Y: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_EPSG25831_Y, data)
    },
    SET_REALESTATE_FLOOR: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_FLOOR, data)
    },
    SET_REALESTATE_FLOOR_NUMBER: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_FLOOR_NUMBER, data)
    },
    SET_REALESTATE_GEOHASH: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_GEOHASH, data)
    },
    SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS, data)
    },
    SET_REALESTATE_ID: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_ID, data)
    },
    SET_REALESTATE_LAT: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_LAT, data)
    },
    SET_REALESTATE_LNG: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_LNG, data)
    },
    SET_REALESTATE_MUNICIPALITY: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_MUNICIPALITY, data)
    },
    SET_REALESTATE_POSTAL_CODE: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_POSTAL_CODE, data)
    },
    SET_REALESTATE_PARENT_PATH: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_PARENT_PATH, data)
    },
    SET_REALESTATE_PATH: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_PATH, data)
    },
    SET_REALESTATE_PROPERTY_TYPE: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_PROPERTY_TYPE, data)
    },
    SET_REALESTATE_PROVINCE: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_PROVINCE, data)
    },
    SET_REALESTATE_REGISTRY_NAME: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_REGISTRY_NAME, data)
    },
    SET_REALESTATE_STAIRCASE: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_STAIRCASE, data)
    },
    SET_REALESTATE_STREET_NAME: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_STREET_NAME, data)
    },
    SET_REALESTATE_STREET_NUMBER: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_STREET_NUMBER, data)
    },
    SET_REALESTATE_MAP_GOOGLE_01_URL: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_MAP_GOOGLE_01_URL, data)
    },
    SET_REALESTATE_MAP_GOOGLE_01_LAT: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_MAP_GOOGLE_01_LAT, data)
    },
    SET_REALESTATE_MAP_GOOGLE_01_LNG: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_MAP_GOOGLE_01_LNG, data)
    },
    SET_REALESTATE_MAP_GOOGLE_01_ZOOM: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_MAP_GOOGLE_01_ZOOM, data)
    },
    SET_REALESTATE_MAP_GOOGLE_02_URL: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_MAP_GOOGLE_02_URL, data)
    },
    SET_REALESTATE_MAP_GOOGLE_02_LAT: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_MAP_GOOGLE_02_LAT, data)
    },
    SET_REALESTATE_MAP_GOOGLE_02_LNG: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_MAP_GOOGLE_02_LNG, data)
    },
    SET_REALESTATE_MAP_GOOGLE_02_ZOOM: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_MAP_GOOGLE_02_ZOOM, data)
    },
    SET_REALESTATE_MAP_GOOGLE_03_URL: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_MAP_GOOGLE_03_URL, data)
    },
    SET_REALESTATE_MAP_GOOGLE_03_LAT: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_MAP_GOOGLE_03_LAT, data)
    },
    SET_REALESTATE_MAP_GOOGLE_03_LNG: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_MAP_GOOGLE_03_LNG, data)
    },
    SET_REALESTATE_MAP_GOOGLE_03_ZOOM: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_MAP_GOOGLE_03_ZOOM, data)
    },
    SET_REALESTATE_FLOOR_TYPE: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_FLOOR_TYPE, data)
    },
    UPDATE_REALESTATE: ({state, commit, rootState}, data) => {

        return new Promise((resolve, reject) => {
            api.update({object: data.object, path: data.path, save_timestamp: true})
                .then((res) => {
                    const date_modified = res.date_modified
                    const reskey = res.key

                    console.log('update realestate data: ')
                    console.log(data)

                    commit(SET_REALESTATE_DATE_MODIFIED, res.date_modified)
                    commit(SET_REALESTATE_DIRTYNESS, false)

                    let parent_object = {}

                    parent_object = {
                        description: check_undefined(data.object.description),
                        id: data.object.id,
                        date_modified: check_undefined(res.date_modified),
                        block: check_undefined(data.object.block),
                        cadastral_reference: check_undefined(data.object.cadastral_reference),
                        door: check_undefined(data.object.door),
                        type: check_undefined(data.object.type),
                        floor: check_undefined(data.object.floor),
                        property_type: check_undefined(data.object.property_type),
                        municipality: check_undefined(data.object.municipality.name_ine),
                        registry_estate_number: check_undefined(data.object.registry_estate_number),
                        registry_name: check_undefined(data.object.registry_name),
                        staircase: check_undefined(data.object.staircase),
                        street_name: check_undefined(data.object.street_name),
                        street_number: check_undefined(data.object.street_number),
                        full_address: check_undefined(data.object.full_address),
                        total_travel_fees: check_undefined(data.object.total_travel_fees),
                        quote_base_price: check_undefined(data.object.quote_base_price),
                        quote_price_incl_travel_expenses: check_undefined(data.object.quote_price_incl_travel_expenses),
                        invoice_base_price: check_undefined(data.object.invoice_base_price),
                        invoice_price_incl_travel_expenses: check_undefined(data.object.invoice_price_incl_travel_expenses)
                    }

                    // if added to report by import from appraisalreport
                    if (data.report_id) {
                        api.set_value({
                            value: true,
                            path: 'appraisalreports' + '/' + data.report_id + '/' + 'realestates' + '/' + data.object.id + '/' + 'id',
                            save_timestamp: false
                        })

                        api.set_value({
                            value: true,
                            path: 'realestates' + '/' + data.key + '/' + 'appraisalreports' + '/' + data.report_id,
                            save_timestamp: false
                        })

                    }

                    // if added to quote by import from appraisalquote
                    if (data.quote_id) {
                        api.set_value({
                            value: true,
                            path: 'appraisalquotes' + '/' + data.quote_id + '/' + 'realestates' + '/' + data.object.id + '/' + 'id',
                            save_timestamp: false
                        })

                        api.set_value({
                            value: true,
                            path: 'realestates' + '/' + data.key + '/' + 'appraisalquotes' + '/' + data.quote_id,
                            save_timestamp: false
                        })

                    }

                    // if added to quote by import from appraisalinvoice
                    if (data.invoice_id) {
                        api.set_value({
                            value: true,
                            path: 'appraisalinvoices' + '/' + data.invoice_id + '/' + 'realestates' + '/' + data.object.id + '/' + 'id',
                            save_timestamp: false
                        })

                        api.set_value({
                            value: true,
                            path: 'realestates' + '/' + data.key + '/' + 'appraisalinvoices' + '/' + data.quote_id,
                            save_timestamp: false
                        })

                    }

                    api.get({path: 'realestates' + '/' + data.key + '/' + 'appraisalreports'})
                        .then((res) => {

                            let appraisalreports = res

                            api.get({path: 'realestates' + '/' + data.key + '/' + 'appraisalquotes'})
                                .then((res) => {

                                    let appraisalquotes = res

                                    if (_.size(appraisalquotes) > 0 || _.size(appraisalreports) > 0) {
                                        _.forEach(appraisalquotes, (value, key) => {
                                            api.update({
                                                object: parent_object,
                                                path: 'appraisalquotes' + '/' + key + '/' + 'realestates' + '/' + data.object.id,
                                                save_timestamp: false
                                            })
                                                .then((res) => {
                                                    resolve({key: reskey})
                                                })

                                        })

                                        _.forEach(appraisalreports, (value, key) => {
                                            api.update({
                                                object: parent_object,
                                                path: 'appraisalreports' + '/' + key + '/' + 'realestates' + '/' + data.object.id,
                                                save_timestamp: false
                                            })
                                                .then((res) => {
                                                    resolve({key: reskey})
                                                })

                                        })
                                    } else {
                                        resolve({key: reskey})

                                    }

                                })

                            api.get({path: 'realestates' + '/' + data.key + '/' + 'appraisalinvoices'})
                                .then((res) => {

                                    let appraisalinvoices = res

                                    if (_.size(appraisalinvoices) > 0 || _.size(appraisalreports) > 0) {
                                        _.forEach(appraisalinvoices, (value, key) => {
                                            api.update({
                                                object: parent_object,
                                                path: 'appraisalinvoices' + '/' + key + '/' + 'realestates' + '/' + data.object.id,
                                                save_timestamp: false
                                            })
                                                .then((res) => {
                                                    resolve({key: reskey})
                                                })

                                        })

                                        _.forEach(appraisalreports, (value, key) => {
                                            api.update({
                                                object: parent_object,
                                                path: 'appraisalreports' + '/' + key + '/' + 'realestates' + '/' + data.object.id,
                                                save_timestamp: false
                                            })
                                                .then((res) => {
                                                    resolve({key: reskey})
                                                })

                                        })
                                    } else {
                                        resolve({key: reskey})

                                    }

                                })

                        })

                })

        })
    },
    UPDATE_REALESTATE_FLOOR_NUMBER: ({state, commit, rootState}, data) => {
        return new Promise((resolve, reject) => {
            commit(SET_REALESTATE_FLOOR_NUMBER, data.floor_number)
            api.set_value({
                value: data.value,
                path: data.path + '/' + 'floor_number',
                save_timestamp: false
            }).then((res) => {

                resolve()

            })

        })
    },
    SET_REALESTATE_FULL_ADDRESS: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_FULL_ADDRESS, data)
    },
    SET_REALESTATE_SHORT_ADDRESS: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_SHORT_ADDRESS, data)
    },
    SET_REALESTATE_BLOCK: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_BLOCK, data)
    },
    SET_REALESTATE_AREA_ADS_MARKERS: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_AREA_ADS_MARKERS, data)
    },
    SET_REALESTATE_AREA_AVERAGE_PRICE: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_AREA_AVERAGE_PRICE, data)
    },
    SET_REALESTATE_AREA_AVERAGE_PRICE_COEF: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_AREA_AVERAGE_PRICE_COEF, data)
    },
    SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE, data)
    },
    SET_REALESTATE_ESTIMATED_BUILT_AREA: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_ESTIMATED_BUILT_AREA, data)
    },
    SET_REALESTATE_PRE_APPRAISAL_VALUE: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_PRE_APPRAISAL_VALUE, data)
    },
    SET_REALESTATE_TRAVEL_ONE_WAY_HOURS: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_TRAVEL_ONE_WAY_HOURS, data)
    },
    SET_REALESTATE_TRAVEL_BOTH_WAYS_HOURS: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_TRAVEL_BOTH_WAYS_HOURS, data)
    },
    SET_REALESTATE_TRAVEL_FEES_PER_HOUR: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_TRAVEL_FEES_PER_HOUR, data)
    },
    SET_REALESTATE_CAR_FUEL_EXPENSES_ONE_WAY: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_CAR_FUEL_EXPENSES_ONE_WAY, data)
    },
    SET_REALESTATE_CAR_FUEL_EXPENSES_BOTH_WAYS: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_CAR_FUEL_EXPENSES_BOTH_WAYS, data)
    },
    SET_REALESTATE_CAR_TOLL_EXPENSES_ONE_WAY: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_CAR_TOLL_EXPENSES_ONE_WAY, data)
    },
    SET_REALESTATE_CAR_TOLL_EXPENSES_BOTH_WAYS: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_CAR_TOLL_EXPENSES_BOTH_WAYS, data)
    },
    SET_REALESTATE_CAR_EXPENSES_ONE_WAY: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_CAR_EXPENSES_ONE_WAY, data)
    },
    SET_REALESTATE_CAR_EXPENSES_BOTH_WAYS: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_CAR_EXPENSES_BOTH_WAYS, data)
    },
    SET_REALESTATE_TOTAL_TRAVEL_FEES: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_TOTAL_TRAVEL_FEES, data)
    },
    SET_REALESTATE_QUOTE_APPRAISAL_TYPE_IS_ECO: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_QUOTE_APPRAISAL_TYPE_IS_ECO, data)
    },
    SET_REALESTATE_QUOTE_BASE_FEES: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_QUOTE_BASE_FEES, data)
    },
    SET_REALESTATE_QUOTE_EXCESS_PCT: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_QUOTE_EXCESS_PCT, data)
    },
    SET_REALESTATE_QUOTE_BASE_PRICE: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_QUOTE_BASE_PRICE, data)
    },
    SET_REALESTATE_QUOTE_BASE_PRICE_COEF: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_QUOTE_BASE_PRICE_COEF, data)
    },
    SET_REALESTATE_AREA_ADS_QUERY_STARTDATE: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_AREA_ADS_QUERY_STARTDATE, data)
    },
    SET_REALESTATE_AREA_ADS_QUERY_LIMITDATE: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_AREA_ADS_QUERY_LIMITDATE, data)
    },
    SET_REALESTATE_AREA_ADS_QUERY_DISTANCE: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_AREA_ADS_QUERY_DISTANCE, data)
    },
    SET_REALESTATE_QUOTE_PRICE_INCL_TRAVEL_EXPENSES: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_QUOTE_PRICE_INCL_TRAVEL_EXPENSES, data)
    },
    SET_REALESTATE_INVOICE_BASE_FEES: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_INVOICE_BASE_FEES, data)
    },
    SET_REALESTATE_INVOICE_EXCESS_PCT: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_INVOICE_EXCESS_PCT, data)
    },
    SET_REALESTATE_INVOICE_BASE_PRICE: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_INVOICE_BASE_PRICE, data)
    },
    SET_REALESTATE_INVOICE_BASE_PRICE_COEF: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_INVOICE_BASE_PRICE_COEF, data)
    },
    SET_REALESTATE_INVOICE_APPRAISAL_TYPE_IS_ECO: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_INVOICE_APPRAISAL_TYPE_IS_ECO, data)
    },
    SET_REALESTATE_QUOTE_EXCESS: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_QUOTE_EXCESS, data)
    },
    SET_REALESTATE_ASSET_TYPE: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_ASSET_TYPE, data)
    },
    SET_REALESTATE_DWELLING_TYPE: ({state, commit, rootState}, data) => {
        commit(SET_REALESTATE_DWELLING_TYPE, data)
    },
}

const mutations = {

    [RESET_REALESTATE] (state) {
        state.appraisalreports = null
        state.block = null
        state.cadastral_reference = null
        state.census_section_code = null
        state.country = {
            iso_3166_alpha2_code: 'ES',
            name_en: 'Spain'
        }
        state.description = null
        state.door = null
        state.floor = null
        state.floor_number = null
        state.geohash = null
        state.google_formatted_address = null
        state.google_viewport = null
        state.lat = null
        state.lng = null
        state.municipality = null
        state.parent_path = null
        state.postal_code = null
        state.property_type = null
        state.province = null
        state.registry_estate_number = null
        state.registry_name = null
        state.staircase = null
        state.street_name = null
        state.street_number = null
        state.type = null
        state.date_created = null
        state.date_modified = null
        state.dirty = false
        state.id = null
        state.path = null
        state.map_google_01_url = null
        state.map_google_01_lat = null
        state.map_google_01_lng = null
        state.map_google_01_zoom = 13

        state.map_google_02_url = null
        state.map_google_02_lat = null
        state.map_google_02_lng = null
        state.map_google_02_zoom = 16

        state.map_google_03_url = null
        state.map_google_03_lat = null
        state.map_google_03_lng = null
        state.map_google_03_zoom = 19

        state.full_address = null
        state.short_address = null

        state.block = null

        state.area_ads_markers = null
        state.area_average_price = null

        state.area_average_price_coef = 0.95
        state.adopted_area_average_price = null
        state.estimated_built_area = null
        state.pre_appraisal_value = null
        state.travel_one_way_hours = null
        state.travel_both_ways_hours = null
        state.travel_fees_per_hour = 20
        state.car_fuel_expenses_one_way = null
        state.car_fuel_expenses_both_ways = null
        state.car_toll_expenses_one_way = null
        state.car_toll_expenses_both_ways = null
        state.car_expenses_one_way = null
        state.car_expenses_both_ways = null
        state.total_travel_fees = null
        state.quote_base_fees = null
        state.quote_excess_pct = null
        state.quote_base_price = null
        state.quote_base_price_coef = 1
        state.quote_appraisal_type_is_eco = null
        state.area_ads_query_startdate = null
        state.area_ads_query_limitdate = null
        state.area_ads_query_distance = 1

        state.quote_price_incl_travel_expenses = null

        state.invoice_base_fees = null
        state.invoice_excess_pct = null
        state.invoice_base_price = null
        state.invoice_base_price_coef = null
        state.invoice_appraisal_type_is_eco = null
        state.quote_excess = null

        state.asset_type = null
        state.dwelling_type = null

        state.floor_type = null

    },
    [SET_REALESTATE] (state, data) {
        // console.log('mutations SET_CONTACT data: ')
        // console.log(data)
        state.appraisalreports = check_undefined(data.appraisalreports)
        state.block = check_undefined(data.block)
        state.cadastral_reference = check_undefined(data.cadastral_reference)
        state.census_section_code = check_undefined(data.census_section_code)
        state.description = check_undefined(data.description)
        state.door = check_undefined(data.door)
        state.epsg25831_x = check_undefined(data.epsg25831_x)
        state.epsg25831_y = check_undefined(data.epsg25831_y)
        state.floor = check_undefined(data.floor)
        state.floor_number = check_undefined(data.floor_number)
        state.geohash = check_undefined(data.geohash)
        state.google_formatted_address = check_undefined(data.google_formatted_address)
        state.lat = check_undefined(data.lat)
        state.lng = check_undefined(data.lng)
        state.municipality = check_undefined(data.municipality)
        state.postal_code = check_undefined(data.postal_code)
        state.property_type = check_undefined(data.property_type)
        state.province = check_undefined(data.province)
        state.registry_estate_number = check_undefined(data.registry_estate_number)
        state.registry_name = check_undefined(data.registry_name)
        state.staircase = check_undefined(data.staircase)
        state.street_name = check_undefined(data.street_name)
        state.street_number = check_undefined(data.street_number)
        state.type = check_undefined(data.type)

        state.map_google_01_url = check_undefined(data.map_google_01_url)
        state.map_google_01_lat = check_undefined(data.map_google_01_lat)
        state.map_google_01_lng = check_undefined(data.map_google_01_lng)
        state.map_google_01_zoom = check_undefined(data.map_google_01_zoom)

        state.map_google_02_url = check_undefined(data.map_google_02_url)
        state.map_google_02_lat = check_undefined(data.map_google_02_lat)
        state.map_google_02_lng = check_undefined(data.map_google_02_lng)
        state.map_google_02_zoom = check_undefined(data.map_google_02_zoom)

        state.map_google_03_url = check_undefined(data.map_google_03_url)
        state.map_google_03_lat = check_undefined(data.map_google_03_lat)
        state.map_google_03_lng = check_undefined(data.map_google_03_lng)
        state.map_google_03_zoom = check_undefined(data.map_google_03_zoom)

        //general data
        state.date_created = check_undefined(data.date_created)
        state.date_modified = check_undefined(data.date_modified)
        state.dirty = false
        state.id = check_undefined(data.id)
        state.path = check_undefined(data.path)
        state.parent_path = check_undefined(data.parent_path)

        state.full_address = check_undefined(data.full_address)
        state.short_address = check_undefined(data.short_address)

        state.block = check_undefined(data.block)

        state.area_ads_markers = check_undefined(data.area_ads_markers)
        state.area_average_price = check_undefined(data.area_average_price)

        state.area_average_price_coef = check_undefined(data.area_average_price_coef)
        state.adopted_area_average_price = check_undefined(data.adopted_area_average_price)
        state.estimated_built_area = check_undefined(data.estimated_built_area)
        state.pre_appraisal_value = check_undefined(data.pre_appraisal_value)
        state.travel_one_way_hours = check_undefined(data.travel_one_way_hours)
        state.travel_both_ways_hours = check_undefined(data.travel_both_ways_hours)
        state.travel_fees_per_hour = check_undefined(data.travel_fees_per_hour)
        state.car_fuel_expenses_one_way = check_undefined(data.car_fuel_expenses_one_way)
        state.car_fuel_expenses_both_ways = check_undefined(data.car_fuel_expenses_both_ways)
        state.car_toll_expenses_one_way = check_undefined(data.car_toll_expenses_one_way)
        state.car_toll_expenses_both_ways = check_undefined(data.car_toll_expenses_both_ways)
        state.car_expenses_one_way = check_undefined(data.car_expenses_one_way)
        state.car_expenses_both_ways = check_undefined(data.car_expenses_both_ways)
        state.total_travel_fees = check_undefined(data.total_travel_fees)
        state.quote_base_fees = check_undefined(data.quote_base_fees)
        state.quote_excess_pct = check_undefined(data.quote_excess_pct)
        state.quote_base_price = check_undefined(data.quote_base_price)
        state.quote_base_price_coef = check_undefined(data.quote_base_price_coef)
        state.quote_appraisal_type_is_eco = check_undefined(data.quote_appraisal_type_is_eco)
        state.area_ads_query_startdate = check_undefined(data.area_ads_query_startdate)
        state.area_ads_query_limitdate = check_undefined(data.area_ads_query_limitdate)
        state.area_ads_query_distance = check_undefined(data.area_ads_query_distance)

        state.quote_price_incl_travel_expenses = check_undefined(data.quote_price_incl_travel_expenses)

        state.invoice_base_fees = check_undefined(data.invoice_base_fees)
        state.invoice_excess_pct = check_undefined(data.invoice_excess_pct)
        state.invoice_base_price = check_undefined(data.invoice_base_price)
        state.invoice_base_price_coef = check_undefined(data.invoice_base_price_coef)
        state.invoice_appraisal_type_is_eco = check_undefined(data.invoice_appraisal_type_is_eco)

        state.quote_excess = check_undefined(data.quote_excess)

        state.asset_type = check_undefined(data.asset_type)
        state.dwelling_type = check_undefined(data.dwelling_type)

        state.floor_type = check_undefined(data.floor_type)

    },
    [SET_REALESTATE_CADASTRAL_REFERENCE] (state, data) {
        state.cadastral_reference = data
        state.dirty = true
    },
    [SET_REALESTATE_CENSUS_SECTION_CODE] (state, data) {
        state.census_section_code = data
        state.dirty = true
    },
    [SET_REALESTATE_COUNTRY] (state, data) {
        state.country = data
        state.dirty = true
    },
    [SET_REALESTATE_DATE_CREATED] (state, data) {
        state.date_created = data
        state.dirty = true
    },
    [SET_REALESTATE_DATE_MODIFIED] (state, data) {
        state.date_modified = data
        state.dirty = true
    },
    [SET_REALESTATE_DESCRIPTION] (state, data) {
        state.description = data
        state.dirty = true
    },
    [SET_REALESTATE_DIRTYNESS] (state, boolean) {
        state.dirty = boolean
    },
    [SET_REALESTATE_DOOR] (state, data) {
        state.door = data
        state.dirty = true
    },
    [SET_REALESTATE_FLOOR] (state, data) {
        state.floor = data
        state.dirty = true
    },
    [SET_REALESTATE_FLOOR_NUMBER] (state, data) {
        state.floor_number = data
        state.dirty = true
    },
    [SET_REALESTATE_GEOHASH] (state, data) {
        state.geohash = data
        state.dirty = true
    },
    [SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS] (state, data) {
        state.google_formatted_address = data
        state.dirty = true
    },
    [SET_REALESTATE_GOOGLE_VIEWPORT] (state, data) {
        state.google_viewport = data
        state.dirty = true
    },
    [SET_REALESTATE_EPSG25831_X] (state, data) {
        state.epsg25831_x = data
        state.dirty = true
    },
    [SET_REALESTATE_EPSG25831_Y] (state, data) {
        state.epsg25831_y = data
        state.dirty = true
    },
    [SET_REALESTATE_ID] (state, data) {
        state.id = data
        state.dirty = true
    },
    [SET_REALESTATE_LAT] (state, data) {
        state.lat = data
        state.dirty = true
    },
    [SET_REALESTATE_LNG] (state, data) {
        state.lng = data
        state.dirty = true
    },
    [SET_REALESTATE_MUNICIPALITY] (state, data) {
        state.municipality = data
        state.dirty = true
    },
    [SET_REALESTATE_PARENT_PATH] (state, data) {
        state.parent_path = data
        state.dirty = true
    },
    [SET_REALESTATE_PATH] (state, data) {
        state.path = data
        state.dirty = true
    },
    [SET_REALESTATE_POSTAL_CODE] (state, data) {
        state.postal_code = data
        state.dirty = true
    },
    [SET_REALESTATE_PROPERTY_TYPE] (state, data) {
        state.property_type = data
        state.dirty = true
    },
    [SET_REALESTATE_PROVINCE] (state, data) {
        state.province = data
        state.dirty = true
    },
    [SET_REALESTATE_REGISTRY_NAME] (state, data) {
        state.registry_name = data
        state.dirty = true
    },
    [SET_REALESTATE_STAIRCASE] (state, data) {
        state.staircase = data
        state.dirty = true
    },
    [SET_REALESTATE_STREET_NAME] (state, data) {
        state.street_name = data
        state.dirty = true
    },
    [SET_REALESTATE_STREET_NUMBER] (state, data) {
        state.street_number = data
        state.dirty = true
    },
    [SET_REALESTATE_MAP_GOOGLE_01_URL] (state, data) {
        state.map_google_01_url = data
        state.dirty = true
    },
    [SET_REALESTATE_MAP_GOOGLE_01_LAT] (state, data) {
        state.map_google_01_lat = data
        state.dirty = true
    },
    [SET_REALESTATE_MAP_GOOGLE_01_LNG] (state, data) {
        state.map_google_01_lng = data
        state.dirty = true
    },
    [SET_REALESTATE_MAP_GOOGLE_01_ZOOM] (state, data) {
        state.map_google_01_zoom = data
        state.dirty = true
    },
    [SET_REALESTATE_MAP_GOOGLE_02_URL] (state, data) {
        state.map_google_02_url = data
        state.dirty = true
    },
    [SET_REALESTATE_MAP_GOOGLE_02_LAT] (state, data) {
        state.map_google_02_lat = data
        state.dirty = true
    },
    [SET_REALESTATE_MAP_GOOGLE_02_LNG] (state, data) {
        state.map_google_02_lng = data
        state.dirty = true
    },
    [SET_REALESTATE_MAP_GOOGLE_02_ZOOM] (state, data) {
        state.map_google_02_zoom = data
        state.dirty = true
    },
    [SET_REALESTATE_MAP_GOOGLE_03_URL] (state, data) {
        state.map_google_03_url = data
        state.dirty = true
    },
    [SET_REALESTATE_MAP_GOOGLE_03_LAT] (state, data) {
        state.map_google_03_lat = data
        state.dirty = true
    },
    [SET_REALESTATE_MAP_GOOGLE_03_LNG] (state, data) {
        state.map_google_03_lng = data
        state.dirty = true
    },
    [SET_REALESTATE_MAP_GOOGLE_03_ZOOM] (state, data) {
        state.map_google_03_zoom = data
        state.dirty = true
    },
    [SET_REALESTATE_FULL_ADDRESS] (state, data) {
        state.full_address = data
        state.dirty = true
    },
    [SET_REALESTATE_SHORT_ADDRESS] (state, data) {
        state.short_address = data
        state.dirty = true
    },
    [SET_REALESTATE_BLOCK] (state, data) {
        state.block = data
        state.dirty = true
    },
    [SET_REALESTATE_AREA_ADS_MARKERS] (state, data) {
        state.area_ads_markers = data
        state.dirty = true
    },
    [SET_REALESTATE_AREA_AVERAGE_PRICE] (state, data) {
        state.area_average_price = data
        state.dirty = true
    },
    [SET_REALESTATE_AREA_AVERAGE_PRICE_COEF] (state, data) {
        state.area_average_price_coef = data
        state.dirty = true
    },
    [SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE] (state, data) {
        state.adopted_area_average_price = data
        state.dirty = true
    },
    [SET_REALESTATE_ESTIMATED_BUILT_AREA] (state, data) {
        state.estimated_built_area = data
        state.dirty = true
    },
    [SET_REALESTATE_PRE_APPRAISAL_VALUE] (state, data) {
        state.pre_appraisal_value = data
        state.dirty = true
    },
    [SET_REALESTATE_TRAVEL_ONE_WAY_HOURS] (state, data) {
        state.travel_one_way_hours = data
        state.dirty = true
    },
    [SET_REALESTATE_TRAVEL_BOTH_WAYS_HOURS] (state, data) {
        state.travel_both_ways_hours = data
        state.dirty = true
    },
    [SET_REALESTATE_TRAVEL_FEES_PER_HOUR] (state, data) {
        state.travel_fees_per_hour = data
        state.dirty = true
    },
    [SET_REALESTATE_CAR_FUEL_EXPENSES_ONE_WAY] (state, data) {
        state.car_fuel_expenses_one_way = data
        state.dirty = true
    },
    [SET_REALESTATE_CAR_FUEL_EXPENSES_BOTH_WAYS] (state, data) {
        state.car_fuel_expenses_both_ways = data
        state.dirty = true
    },
    [SET_REALESTATE_CAR_TOLL_EXPENSES_ONE_WAY] (state, data) {
        state.car_toll_expenses_one_way = data
        state.dirty = true
    },
    [SET_REALESTATE_CAR_TOLL_EXPENSES_BOTH_WAYS] (state, data) {
        state.car_toll_expenses_both_ways = data
        state.dirty = true
    },
    [SET_REALESTATE_CAR_EXPENSES_ONE_WAY] (state, data) {
        state.car_expenses_one_way = data
        state.dirty = true
    },
    [SET_REALESTATE_CAR_EXPENSES_BOTH_WAYS] (state, data) {
        state.car_expenses_both_ways = data
        state.dirty = true
    },
    [SET_REALESTATE_TOTAL_TRAVEL_FEES] (state, data) {
        state.total_travel_fees = data
        state.dirty = true
    },
    [SET_REALESTATE_QUOTE_BASE_FEES] (state, data) {
        state.quote_base_fees = data
        state.dirty = true
    },
    [SET_REALESTATE_QUOTE_EXCESS_PCT] (state, data) {
        state.quote_excess_pct = data
        state.dirty = true
    },
    [SET_REALESTATE_QUOTE_BASE_PRICE] (state, data) {
        state.quote_base_price = data
        state.dirty = true
    },
    [SET_REALESTATE_QUOTE_BASE_PRICE_COEF] (state, data) {
        state.quote_base_price_coef = data
        state.dirty = true
    },
    [SET_REALESTATE_QUOTE_APPRAISAL_TYPE_IS_ECO] (state, data) {
        state.quote_appraisal_type_is_eco = data
        state.dirty = true
    },
    [SET_REALESTATE_AREA_ADS_QUERY_STARTDATE] (state, data) {
        state.area_ads_query_startdate = data
        state.dirty = true
    },
    [SET_REALESTATE_AREA_ADS_QUERY_LIMITDATE] (state, data) {
        state.area_ads_query_limitdate = data
        state.dirty = true
    },
    [SET_REALESTATE_AREA_ADS_QUERY_DISTANCE] (state, data) {
        state.area_ads_query_distance = data
        state.dirty = true
    },
    [SET_REALESTATE_QUOTE_PRICE_INCL_TRAVEL_EXPENSES] (state, data) {
        state.quote_price_incl_travel_expenses = data
        state.dirty = true
    },
    [SET_REALESTATE_INVOICE_BASE_FEES] (state, data) {
        state.invoice_base_fees = data
        state.dirty = true
    },
    [SET_REALESTATE_INVOICE_EXCESS_PCT] (state, data) {
        state.invoice_excess_pct = data
        state.dirty = true
    },
    [SET_REALESTATE_INVOICE_BASE_PRICE] (state, data) {
        state.invoice_base_price = data
        state.dirty = true
    },
    [SET_REALESTATE_INVOICE_BASE_PRICE_COEF] (state, data) {
        state.invoice_base_price_coef = data
        state.dirty = true
    },
    [SET_REALESTATE_INVOICE_APPRAISAL_TYPE_IS_ECO] (state, data) {
        state.invoice_appraisal_type_is_eco = data
        state.dirty = true
    },
    [SET_REALESTATE_QUOTE_EXCESS] (state, data) {
        state.quote_excess = data
        state.dirty = true
    },
    [SET_REALESTATE_ASSET_TYPE] (state, data) {
        state.asset_type = data
        state.dirty = true
    },
    [SET_REALESTATE_DWELLING_TYPE] (state, data) {
        state.dwelling_type = data
        state.dirty = true
    },
    [SET_REALESTATE_FLOOR_TYPE] (state, data) {
        state.floor_type = data
        state.dirty = true
    },

}

function check_undefined (myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar
    } else {
        return null
    }
}

const getters = {

    realestate: state => {
        return state
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/realestate/realestate.js